import CoopUser from './CoopUser';

export default CoopUser;
